<template>
  <div class="listTable mt-1">
    <div class="d-flex">
      <div class="mr-2 pt-1 text-muted">
        {{ notes.length }} notes
        <span v-if="selected.length > 0" class="font-weight-bold">
          | {{ selected.length }} selected
          <button
            class="btn btn-sm btn-secondary mb-1 mx-2"
            @click="deleteNote"
          >
            Delete
          </button>
        </span>
      </div>
      <input
        type="text"
        class="form-control form-control-sm w-50 ml-auto"
        placeholder="Start typing to filter"
        id="filter"
        v-model="searchTerm"
      />
    </div>
    <table class="table table-sm mt-3">
      <thead>
        <tr>
          <th scope="col">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="selectAll"
                v-model="selectAll"
                @click="checkAll"
              />
              <label class="custom-control-label" for="selectAll"></label>
            </div>
          </th>
          <th scope="col">
            Note title
            <!-- <i class="fas fa-sort" @click="sortTitle"></i> -->
          </th>
          <th scope="col" class="px-1 text-right">References</th>
          <th scope="col">Modified</th>
          <!-- <th scope="selector"></th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="note in notes" :key="note.id">
          <td class>
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                :id="note.id"
                :value="note.id"
                v-model="selected"
                :disabled="note.id === rootNote.id"
              />
              <label class="custom-control-label" :for="note.id"></label>
            </div>
          </td>
          <td>
            <i
              class="text-muted fas fa-fw fa-home mr-2"
              v-if="note.id === rootNote.id"
            />
            <a @click="goTo(note)">{{ note.title }}</a>
          </td>
          <td class="text-muted text-right px-1">
            <template v-if="note.links.from.length > 0">
              <span class="badge badge-pill badge-light">
                <i class="fas fa-fw fa-sign-out-alt mr-1 text-muted"></i>
                {{ note.links.from.length > 0 ? note.links.from.length : "" }}
              </span>
            </template>
          </td>
          <td class="text-muted modified">
            {{ formatModified(note.modified) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { distanceInWords, isToday, format } from 'date-fns'
// import _ from 'lodash'
import goToNote from '@/mixins/go-to-note'
export default {
  mixins: [goToNote],
  methods: {
    checkAll() {
      this.selected = (!this.selectAll) ? this.$store.getters.notes.map(note => note.id) : this.selected = []
    },
    deleteNote() {
      for (let x in this.selected) {
        let note = this.$store.getters.getNoteById(this.selected[x])
        this.$store.dispatch('deleteNote', note)
      }
    },
    sortTitle() {
      console.log('sort')
    },
    sortModified() {

    },
    formatModified(timestamp) {
      let dateDistanceInWords = distanceInWords(
        new Date(timestamp),
        new Date()
      ) + ' ago'

      return isToday(timestamp) ? dateDistanceInWords : format(timestamp, 'D MMMM [at] HH:mm ')
    },
    goTo(note) {
      if (note.id) this.goToNote(note.id)
    }
  },
  computed: {
    rootNote() {
      return this.$store.getters.rootNote
    },
    notes() {
      if (this.searchTerm) {
        return [...this.$store.getters.notes]
          .sort((a, b) => b.modified - a.modified)
          .filter(note => note.title.toLowerCase().includes(this.searchTerm.toLowerCase()))
      } else {
        return [...this.$store.getters.notes].sort((a, b) => b.modified - a.modified)
      }
    }
  },
  data() {
    return {
      sortTitleMode: '',
      searchTerm: '',
      selected: [],
      selectAll: false
    }
  }
}
</script>

<style lang="scss" scoped>
th {
  font-size: 0.9rem;
  background-color: #f8f8f8;
}
.modified {
  font-size: 0.8rem;
}
tr:hover td {
  background-color: $gray-100;
}
td:nth-child(1) {
  width: 4%;
}
td:nth-child(2) {
  width: 54%;
}
td:nth-child(3) {
  width: 16%;
}
th:nth-child(4),
td:nth-child(4) {
  width: 13%;
  text-align: center;
}
th:nth-child(5),
td:nth-child(5) {
  width: 13%;
  text-align: center;
}
.listTable {
  margin-left: -1rem;
  margin-right: -1rem;
}
</style>
